// formatDate.js
import { ref, onMounted, onUnmounted } from "vue";
import moment from "moment";
// by convention, composable function names start with "use"
export function useFormatDate(isoDate) {
  // Add validation for null, undefined, or empty values
  // if (!isoDate || isoDate === "" || isoDate === null || isoDate === undefined) {
  //   return "Not Scheduled";
  // }

  const incData = moment(isoDate).format("YYYY-MM-DD");
  // console.log("   FOUND ..........      incData");
  // console.log(incData);

  if (
    isoDate === "01/01/0001" ||
    isoDate === "01/01/0001" ||
    isoDate === "1/1/1901" ||
    isoDate === "1/1/1900" ||
    isoDate === "12/31/1900" ||
    isoDate === "12/31/2099" ||
    isoDate === "2099-12-31" ||
    isoDate === "2099-12-30" ||
    isoDate === "0001-01-01T06:00:00Z" ||
    isoDate === "2099-12-31T06:00:00Z" ||
    isoDate === "1900-01-01T00:00:00Z"
  ) {
    return "Not Scheduled";
  } else {
    // Add additional validation to ensure the date is valid
    const momentDate = moment(isoDate);
    if (!momentDate.isValid()) {
      return "*** Not Scheduled";
    }

    // console.log("isoDate", isoDate);
    // console.log(momentDate.format("L LT"));
    return momentDate.format("L LT");
  }

  onMounted(() => {
    // const incDate = date
    // console.log('useFormatDate')
    // console.log(incData)
    // alert(' userFormatDate MOUNTED')
  });
  //   return incData;
}
export function useFormatDateTime(isoDate) {
  return moment(isoDate).format("L");

  onMounted(() => {
    // const incDate = date
    // console.log('useFormatDateTime')
    // console.log(incData)
    // alert(' userFormatDate MOUNTED')
  });
  //   return incData;
}
